import React from 'react';
import { MdClose } from 'react-icons/md';
import { PiUser } from "react-icons/pi";
import { NavLink } from 'react-router-dom';

const Sidenav = ({ isOpen, onClose, paths }) => {
  return (
    <div id='Sidenav' className={`Sidenav ${isOpen ? 'open' : ''}`}>
      <div className="SidenavOverlay" onClick={onClose}></div>
      <div className="SidenavContent">
        <button className="CloseButton" onClick={onClose}>
          <MdClose />
        </button>
        
        <div className="LoginButtonBox">
          <NavLink to={paths.login} className="LoginButton" onClick={onClose}>
            <PiUser className="UserIcon" />
            <span>Login / Signup</span>
          </NavLink>
        </div>
        
        <div className="SidenavLinks">
          {Object.entries(paths).map(([key, path]) => (
            !['account', 'search', 'wishlist', 'cart', 'login'].includes(key) && (
              <NavLink 
                key={key} 
                to={path} 
                className="SidenavLink" 
                onClick={onClose}
              >
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </NavLink>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidenav;